import { LoanApplication, Vehicle, Customer } from "src/types/loan-application/index";
import { QuickQuote } from "src/types/quote/index";

export default function useMapQuickQuoteToLoanApplication(qq: QuickQuote) {
  const a = {
    affiliateUserId: qq.affiliateUserId,
    created: qq.created,
    createdBy: qq!.createdBy,
    loanAmount: (qq.price ?? 0) - (qq.deposit ?? 0) - (qq.partExValue ?? 0) + (qq.partExSettlement ?? 0),
    deposit: qq.deposit,
    settlement: qq.partExSettlement,
    settlementFinanceCompany: qq.settlementFinanceCompany,
    pxValue: qq.partExValue,
    pxReg: qq.partExRegistration,
    pxMileage: qq.partExMileage ? qq.partExMileage.toString() : null,
    pxMake: qq.partExMake,
    pxModel: qq.partExModel,
    term: qq.term,
    customer: {
      firstName: qq.firstName,
      lastName: qq.surname,
      contactNumber: qq.mobile,
      email: qq.email
    } as Customer,
    vehicle: {
      vehicleId: qq.vehicleId,
      make: qq.make,
      model: qq.model,
      registrationDate: new Date(qq.registrationDate ?? new Date()),
      vrm: qq.registration ?? "",
      vehicleDateOfFirstReg: new Date(qq.registrationDate ?? new Date()),
      mileage: qq.mileage,
      price: qq.price,
      transmission: qq.transmission,
      fuel: qq.fuelType,
      capRetail: qq.capRetail,
      capClean: qq.capClean,
      capAverage: qq.capAverage,
      capCreatedOn: qq.capCreatedOn ? new Date(qq.capCreatedOn) : null,
      annualMileage: qq.annualMileage
    } as Vehicle,
    isQuickQuote: true,
    quickQuoteId: qq.quickQuoteId,
    quickQuote: qq,
    creditProfile: qq.creditProfile,
    state: -1,
    productType: qq.productType
  } as LoanApplication;

  return new LoanApplication(a);
}
